export default "__VITE_ASSET__BHeSmVy$__"